var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOverSpeedEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Over Speed Events",
    role: "img",
    viewBox: "0 0 100 86",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Over Speed Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.1726,27.4788c-0.54-1.3502-2.0708-2.0063-3.419-1.4654 c-1.3482,0.5408-2.0033,2.0738-1.4633,3.424c0.02,0.0501,0.0416,0.0995,0.0647,0.1483 c8.2765,19.0262,0.9097,41.2411-17.0877,51.5287c-1.2417,0.7544-1.6377,2.374-0.8844,3.6176 c0.7232,1.194,2.2513,1.615,3.4826,0.9596C97.2063,74.0769,105.5322,48.9733,96.1726,27.4788"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5915,80.9142c-16.0242-9.102-23.7763-27.9817-18.7812-45.7401H9.3827 c-4.8833,19.7203,3.942,40.2845,21.5897,50.3067c1.2592,0.7272,2.8686,0.2945,3.5948-0.9665 c0.7262-1.261,0.2941-2.8729-0.9651-3.6001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9526,4.0083C67.0415,1.3586,60.6371-0.0075,54.1609,0h-0.2104 c-8.7681-0.0004-17.3504,2.5305-24.719,7.2898l3.2187,4.2137c6.44-4.0616,13.8949-6.218,21.5055-6.2205h0.1841 c5.7417-0.0065,11.4199,1.2033,16.6617,3.5501c1.3094,0.6291,2.8802,0.0761,3.5084-1.2353 c0.6282-1.3114,0.0759-2.8845-1.2335-3.5136c-0.0442-0.0212-0.089-0.0412-0.1343-0.06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2423,16.5021c1.009-1.0462,0.9801-2.7134-0.0645-3.7239 c-1.0191-0.9858-2.6348-0.9858-3.6539,0L60.9086,35.427c-5.8288-3.8982-13.7093-2.3262-17.6018,3.5112 s-2.3227,13.7297,3.506,17.6279s13.7093,2.3262,17.6018-3.5112c2.7842-4.1755,2.853-9.6012,0.1755-13.8461L87.2423,16.5021z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1371,30.4284H2.6297C1.1773,30.4284,0,29.2493,0,27.7949 c0-0.5698,0.1845-1.1243,0.5259-1.5802L17.2928,4.3191c0.9637-1.1534,2.6786-1.306,3.8303-0.3409 c0.1233,0.1033,0.2372,0.2174,0.3404,0.3409l16.7458,21.8745c0.8714,1.1636,0.6359,2.8143-0.5259,3.687 c-0.4552,0.3419-1.0088,0.5267-1.5778,0.5267"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverSpeedEvents);
export default __webpack_public_path__ + "static/media/over-speed-events.13d5c13eaf447b5a47a3cadcb713abb1.svg";
export { ForwardRef as ReactComponent };